import { Breadcrumb, EventHandler } from "client/CommonComponents";
import AssessmentQuestion from "../AssessmentQuestion";
import './EditAssessmentQuestion.scss'

const EditAssessmentQuestion = (props:any) => {
    const { assessmentById = {}, handleClickBack } = props
    const { numberOfQuestion, assessmentTitle, passingPercentage, } = assessmentById

    return(<>
        <div className='breadCrumbBlock'>
            <EventHandler onEvent={props.handleClickBack} data-attribute="EditAssessmentQuestion_Default_EventHandler">
                <div className='backButton mb-sm-0 mb-3'>
                    <span className="fa fa-chevron-left"></span> Back
                </div>
            </EventHandler>
            <div className='breadcrumbList'>
                <Breadcrumb items={props.breadcrumlist} maxDisplayedItems="5"  data-attribute="EditAssessmentQuestion_Default_Breadcrumb" />
            </div>
        </div>
        <AssessmentQuestion 
        quantity={numberOfQuestion}
        assessmentTitle={assessmentTitle}
        passingPercentage={passingPercentage}
        handleClickBack={handleClickBack}
        assessmentById={assessmentById}
        isEditMode={true}
        />
    </>)
}

export default EditAssessmentQuestion;